import { render, staticRenderFns } from "./ActionMenu.vue?vue&type=template&id=453e643c&scoped=true&"
import script from "./ActionMenu.vue?vue&type=script&lang=js&"
export * from "./ActionMenu.vue?vue&type=script&lang=js&"
import style0 from "./ActionMenu.vue?vue&type=style&index=0&id=453e643c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453e643c",
  null
  
)

export default component.exports